// removed by extract-text-webpack-plugin
module.exports = {"row":"_1SG4P","container":"_IiIGt","content":"_2rRAo"};


//////////////////
// WEBPACK FOOTER
// ./app/containers/Terms/Terms.scss
// module id = 1613
// module chunks = 20